module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "new-users-panel"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "form-group col-xs-6 col-sm-6 col-md-6"
  }, [_c('label', {
    staticClass: "required"
  }, [_vm._v("Country")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('nv-select', {
    staticClass: "form-control",
    on: {
      "change": _vm.selectedCountry
    },
    model: {
      value: (_vm.gRowObj.country_id),
      callback: function($$v) {
        _vm.$set(_vm.gRowObj, "country_id", $$v)
      },
      expression: "gRowObj.country_id"
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("--Choose a Country--")]), _vm._v(" "), _vm._l((_vm.countryList), function(data) {
    return _c('option', {
      key: data.country_id,
      domProps: {
        "value": data.country_id
      }
    }, [_vm._v(_vm._s(data.country_name))])
  })], 2), _vm._v(" "), (_vm.submitted && !_vm.gRowObj.country_id) ? _c('span', {
    staticClass: "text-red"
  }, [_vm._v("Please choose a country.")]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group col-xs-6 col-sm-6 col-md-6"
  }, [_c('label', {
    staticClass: "required"
  }, [_vm._v("Customer")]), _vm._v(" "), _c('nv-select', {
    staticClass: "form-control",
    on: {
      "change": _vm.selectedClient
    },
    model: {
      value: (_vm.gRowObj.client_id),
      callback: function($$v) {
        _vm.$set(_vm.gRowObj, "client_id", $$v)
      },
      expression: "gRowObj.client_id"
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("--Choose a Customer--")]), _vm._v(" "), _vm._l((_vm.clientList), function(data) {
    return _c('option', {
      key: data.id,
      domProps: {
        "value": data.id
      }
    }, [_vm._v(_vm._s(data.name))])
  })], 2), _vm._v(" "), (_vm.submitted && !_vm.gRowObj.client_id) ? _c('span', {
    staticClass: "text-red"
  }, [_vm._v("Please choose a customer.")]) : _vm._e()], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "form-group col-xs-8 col-sm-8 col-md-8"
  }, [_c('label', {
    staticClass: "required"
  }, [_vm._v("Segment Name")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.gRowObj.audience_name),
      expression: "gRowObj.audience_name"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Segment Name"
    },
    domProps: {
      "value": (_vm.gRowObj.audience_name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.gRowObj, "audience_name", $event.target.value)
      }
    }
  }), _vm._v(" "), (_vm.submitted && !(_vm.gRowObj.audience_name || '').trim()) ? _c('span', {
    staticClass: "text-red"
  }, [_vm._v("Please click Generate Segment Name or enter one.")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-xs-4 col-sm-4 col-md-4"
  }, [_c('button', {
    staticClass: "btn btn-primary new-users-generate-btn",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.generateAudience
    }
  }, [_vm._v("Generate Segment Name")])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "form-group col-xs-6 col-sm-6 col-md-6"
  }, [_c('label', {
    staticClass: "required"
  }, [_vm._v("Google Sheet URL")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.gRowObj.spreadsheetURL),
      expression: "gRowObj.spreadsheetURL"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Google Sheet URL"
    },
    domProps: {
      "value": (_vm.gRowObj.spreadsheetURL)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.gRowObj, "spreadsheetURL", $event.target.value)
      }
    }
  }), _vm._v(" "), (_vm.submitted && !(_vm.gRowObj.spreadsheetURL || '').trim()) ? _c('span', {
    staticClass: "text-red"
  }, [_vm._v("Please enter the Google Sheet URL.")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-xs-6 col-sm-6 col-md-6"
  }, [_c('label', {
    staticClass: "checkbox-inline new-users-jor-check"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.gRowObj.isUploadInJOR),
      expression: "gRowObj.isUploadInJOR"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.gRowObj.isUploadInJOR) ? _vm._i(_vm.gRowObj.isUploadInJOR, null) > -1 : (_vm.gRowObj.isUploadInJOR)
    },
    on: {
      "change": [function($event) {
        var $$a = _vm.gRowObj.isUploadInJOR,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.gRowObj, "isUploadInJOR", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.gRowObj, "isUploadInJOR", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.gRowObj, "isUploadInJOR", $$c)
        }
      }, _vm.onJorToggle]
    }
  }), _vm._v("\n        Onboard users to JOR?\n        "), _vm._m(1)])])]), _vm._v(" "), (_vm.gRowObj.isUploadInJOR) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "form-group col-xs-6 col-sm-6 col-md-6"
  }, [_c('label', {
    staticClass: "required"
  }, [_vm._v("User Journey")]), _vm._v(" "), _c('treeselect', {
    attrs: {
      "placeholder": "--Choose a journey--",
      "multiple": false,
      "options": _vm.conversationApps
    },
    model: {
      value: (_vm.gRowObj.conversation),
      callback: function($$v) {
        _vm.$set(_vm.gRowObj, "conversation", $$v)
      },
      expression: "gRowObj.conversation"
    }
  }), _vm._v(" "), (_vm.submitted && !_vm.gRowObj.conversation) ? _c('span', {
    staticClass: "text-red"
  }, [_vm._v("Please choose a journey.")]) : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "help-block"
  }, [_vm._v("JOR onboarding requires a journey-type app — only journeys are listed here.")])], 1)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "action-button"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.uploadUsers
    }
  }, [_vm._v("Submit")])]), _vm._v(" "), _c('div', {
    staticClass: "new-users-instructions"
  }, [_c('label', [_vm._v("Instructions")]), _vm._v(" "), _c('ul', [_vm._m(2), _vm._v(" "), _vm._m(3), _vm._v(" "), _c('li', [_vm._v("Phone Number: include the country code, no special characters.")]), _vm._v(" "), _vm._m(4), _vm._v(" "), _vm._m(5), _vm._v(" "), _c('li', [_vm._v("Country: capitalize the first letter (e.g. " + _vm._s(_vm.activeCountryList.join(', ')) + ").")]), _vm._v(" "), _vm._m(6)])]), _vm._v(" "), (_vm.loading) ? _c('BlockUI', [_c('i', {
    staticClass: "fa fa-cog fa-spin fa-3x fa-fw"
  }), _c('br'), _vm._v("Please wait...")]) : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    attrs: {
      "title": "The audience query will only work for the country selected here."
    }
  }, [_c('i', {
    staticClass: "fa fa-info-circle"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    attrs: {
      "title": "Schedules these users directly into a journey's reminder flow — only needed for that."
    }
  }, [_c('i', {
    staticClass: "fa fa-info-circle"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_vm._v("Upload the Google Sheet into "), _c('a', {
    attrs: {
      "href": "https://drive.google.com/drive/folders/1Vb7nmtQoqEvBFjW3LqoSUtfptnx5u6sq",
      "target": "_blank"
    }
  }, [_vm._v("this folder")]), _vm._v(".")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_vm._v("Columns must be in this exact order: "), _c('strong', [_vm._v("Phone Number, Language, Gender, Age, Pincode, Country")]), _vm._v(".")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_vm._v("Language: one of "), _c('code', [_vm._v("eng, hi, swa, hau")]), _vm._v(".")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_vm._v("Gender: one of "), _c('code', [_vm._v("man, woman, nonbinary")]), _vm._v(".")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_vm._v("Reference sheet: "), _c('a', {
    attrs: {
      "href": "https://docs.google.com/spreadsheets/d/18HVveQmCpHEAnddx3Neaxem1wITtPlMCr0QpDq_e03I/edit?usp=sharing",
      "target": "_blank"
    }
  }, [_vm._v("demo template")]), _vm._v(".")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-61e86ea0","transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/audience-builder/ai-audience/NewUsersUploadPanel.vue
// module id = cESE
// module chunks = 1